import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { BuyerPlatFormActions, MerchantActions } from "../../actions";


const AutocompleteBuyerPlatform = (props) => {
    const [buyerPlatform, setBuyerPlatform] = useState([]);
    const [merchatList, setMerchatList] = useState([]);

    useEffect(() => {
        /*  props.getBuyerPlatform().then(() => {
             let buyerPlatform = [];
             props.buyerPlatforms.map(item => {
                 buyerPlatform.push({
                     "id": item.id,
                     "name": item.name
                 });
             })
             setBuyerPlatform(buyerPlatform);
         }) */
        /*  props.getMerchantList().then(() => {
             console.log("merchantsMerchantList:::::::::::", props.MerchantList)
 
             let merchants = [];
             props.MerchantList.map(item => {
                 merchants.push({
                     "id": item.id,
                     "name": item.company ? item.company.tradeName : item.user.email,
                     "email": item.user.email,
                     "user": item.user.name
                 });
             })
             console.log("merchants:::::::::::", merchants)
             setMerchatList(merchants);
         }).catch((e) => console.log(e)) */
        let merchants = [];
        if(props.merchantList && props.merchantList.length > 0){
            props.merchantList.map(item => {
                merchants.push({
                    "id": item.id,
                    "name": item.company ? item.company.tradeName : item.user.email,
                    "email": item.user.email,
                    "user": item.user.name
                });
            })
        }
        setMerchatList(merchants);
    }, [props]);

    const handleOnSelect = (item) => {
        props.getItemData(item);
    }

    const onClear = () => {
        props.onClear()
    }

    return (
        <ReactSearchAutocomplete
            items={merchatList}
            onSelect={handleOnSelect}
            fuseOptions={{ keys: ["name", "email", "user"] }}
            autoFocus
            placeholder={"All Merchant"}
            onClear={onClear}
            styling={{
                zIndex: "999",
            }}            
            inputSearchString={props.merchantName ? props.merchantName : ''}
        // onHover={handleOnHover}

        />
    )
}
const mapStateToProps = ({ BuyerPlatFormReducers, MerchantListReducer }) => {
    return {
        buyerPlatforms: BuyerPlatFormReducers.buyerPlatforms,
        MerchantList: MerchantListReducer?.merchantList?.content
    }
};

const mapDispatchToProps = {
    getBuyerPlatform: BuyerPlatFormActions.getBuyerPlatform,
    getMerchantList: MerchantActions.getMerchantList
};

export default connect(mapStateToProps, mapDispatchToProps)(AutocompleteBuyerPlatform);
